import { apiClient } from './api';

export interface ServiceStatus {
  connected: boolean;
  error?: string | null;
  expiresAt?: string | null;
}

export interface SystemStatusResponse {
  success: boolean;
  timestamp: string;
  services: {
    salesforce: ServiceStatus;
    sage: ServiceStatus;
    vault: ServiceStatus;
  };
}

/**
 * Fetch the real-time system status for all services
 */
export async function getSystemStatus(): Promise<SystemStatusResponse> {
  const response = await apiClient.get<SystemStatusResponse>('/api/status');
  return response.data;
}
